<template>
  <table>
    <tr>
      <td :style="mainStyle">
        <br>
        <b v-if="name" :style="nameStyle">{{name}}, </b>{{jobTitle}}<br>
        <a v-if="email" :href="`mailto:${email}`" :style="linkStyle">{{email}}</a>
        <template v-if="extension || mobile"> <Separator :color="colors.darkGrey" character="•"/> </template>
        <template v-if="extension">0203 745 5{{ extension }}</template><template v-if="extension && mobile"> <Separator :color="colors.darkGrey" character="•"/> </template><template v-if="mobile">{{ mobile }}</template>
        <template v-if="extraInfo"><br><br><b :style="extraInfoStyle">{{ extraInfo }}</b></template>
        <template v-if="email || extension || mobile"><br><br></template>

        <div>
          <table>
            <tr>
              <td valign="middle" :style="footerLogoCellStyle" width="190">
                <email-safe-image url="https://fivium.co.uk/email-signatures/fivium-digital-white.png" :width="150" :height="43" :email-app="emailApp" alt="Fivium Digital" :paddingRight="20" :paddingLeft="20"/>
              </td>
              <td valign="middle" :style="footerTextCellStyle">
                <span :style="nowrap">15 Adam Street</span>, London, <span :style="nowrap">WC2N 6AH</span>
                <Separator :color="colors.darkGrey" character="•"/>
                <a href="https://www.fivium.co.uk" target="_blank" :style="footerLinkStyle">fivium.co.uk</a>
                <Separator :color="colors.darkGrey" character="•"/>
                <span :style="nowrap">0800 3689 345</span>
                <br>
                Follow us on <a href="https://linkedin.com/company/fivium/" target="_blank" :style="footerLinkStyle">LinkedIn</a>
                <Separator :color="colors.darkGrey" character="•"/>
                Twitter <a href="https://twitter.com/FiviumUK" target="_blank" :style="footerLinkStyle">@FiviumUK</a>
                <Separator :color="colors.darkGrey" character="•"/>
                Facebook <a href="https://facebook.com/fivium" target="_blank" :style="footerLinkStyle">@Fivium</a>
              </td>
            </tr>
            <tr v-if="hasCta">
              <td colspan="2" :style="footerCTAStyle">
                <span :style="footerCTATextStyle" v-html="ctaText"></span>
                <a :href="ctaLinkUrl" :style="footerCTALinkStyle" target="_blank">{{ ctaLinkText }}</a>
              </td>
            </tr>
          </table>
        </div>

      </td>
    </tr>
  </table>
</template>

<script>
import EmailSafeImage from "@/components/EmailSafeImage";
import Separator from "@/components/Separator";

export default {
  name: "SignatureTemplateFiviumDigital",
  components: { EmailSafeImage, Separator },
  props: [
    'name',
    'jobTitle',
    'email',
    'extension',
    'mobile',
    'extraInfo',
    'emailApp',
    'ctaText',
    'ctaLinkUrl',
    'ctaLinkText',
    'showCta'
  ],
  data() {
    const colors = {
      pink: '#da1884',
      purple: '#7a2682',
      lightBlue: '#00c1de',
      midBlue: '#455ba6',
      darkBlue: '#00263e',
      lighterGrey: '#f0f3f3',
      lightGrey: '#d9dfe1',
      midGrey: '#a2bac2',
      darkGrey: '#748693',
      darkerGrey: '#415464',
      white: '#ffffff',
      linkBlue: '#15c'
    };

    const fontFamily = 'Arial, Helvetica, sans-serif';
    const fontSize = '13.333px';

    return {
      colors: colors,
      fontFamily: fontFamily,
      fontSize: fontSize,
      nameStyle: {
        color: colors.darkBlue,
        fontWeight: 'bold',
        fontSize: fontSize,
        fontFamily: fontFamily
      },
      extraInfoStyle: {
        color: colors.darkBlue,
        fontWeight: 'bold',
        fontSize: fontSize,
        fontFamily: fontFamily
      },
      linkStyle: { color: colors.linkBlue },
      mainStyle: {
        color: colors.darkerGrey,
        fontSize: fontSize,
        fontFamily: fontFamily
      },
      footerLinkStyle: {
        color: colors.linkBlue,
        textDecoration: 'underline',
        whiteSpace: 'nowrap'
      },
      footerCTAStyle: {
        borderTop: `3px solid ${colors.pink}`,
        borderRadius: '0 0 5px 5px',
        backgroundColor: colors.lightGrey,
        color: colors.darkBlue,
        padding: '15px 20px',
        textAlign: 'center'
      },
      footerCTATextStyle: {
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeight: 'bold'
      },
      footerCTALinkStyle: {
        textDecoration: 'underline',
        color: colors.linkBlue,
        fontWeight: 'bold',
        fontFamily: fontFamily,
        fontSize: fontSize
      },
      nowrap: {
        whiteSpace: 'nowrap'
      }
    }
  },
  computed: {
    footerLogoCellStyle() {
      return {
        background: this.colors.darkBlue,
        borderRadius: `5px 0 0 ${this.hasCta ? 0 : 5}px`}
    },
    footerTextCellStyle() {
      return {
        padding: '20px',
        borderRadius: '0 5px 5px 0',
        background: this.colors.lighterGrey,
        color: this.colors.darkBlue,
        fontSize: this.fontSize,
        fontFamily: this.fontFamily
      }
    },
    hasCta() {
      return (this.ctaText || (this.ctaLinkText && this.ctaLinkUrl)) && this.showCta
    }
  }
}
</script>

<style scoped>

</style>
